module.exports = __webpack_public_path__ + "1ef7fa9e5ef4dc0c55451c8a7f128aa1.svg";